import axiosClient from "./axiosClient"

const loginApi = {
    signIn(infoUser) {
        const url = '/signin'
        return axiosClient.post(url, infoUser)
    }
}

export default loginApi